import { Action } from '@ngrx/store';
import { DealMetrics } from '../../services/deal-metrics.service';

export enum DealMetricsActionTypes {
  Load = '[DealMetrics] Load',
  LoadSuccess = '[DealMetrics] Load Success',
  LoadFail = '[DealMetrics] Load Fail',
  SaveScore = '[DealMetrics] Save Score Users',
  SaveScoreSuccess = '[DealMetrics] Save Score Success',
  SaveScoreFail = '[DealMetrics] Save Score Fail',
  SaveRating = '[DealMetrics] Save Rating',
  SaveRatingSuccess = '[DealMetrics] Save Rating Success',
  SaveRatingFail = '[DealMetrics] Save Rating Fail',
  SaveOwnership = '[DealMetrics] Save Ownership',
  SaveOwnershipSuccess = '[DealMetrics] Save Ownership Success',
  SaveOwnershipFail = '[DealMetrics] Save Ownership Fail',
  SaveStatus = '[DealMetrics] Save Status',
  SaveStatusSuccess = '[DealMetrics] Save Status Success',
  SaveStatusFail = '[DealMetrics] Save Status Fail'
}

export class LoadDealMetrics implements Action {
  public readonly type = DealMetricsActionTypes.Load;

  constructor(public payload: string) {}
}

export class LoadDealMetricsSuccess implements Action {
  public readonly type = DealMetricsActionTypes.LoadSuccess;

  constructor(public payload: DealMetrics) {}
}

export class LoadDealMetricsFail implements Action {
  public readonly type = DealMetricsActionTypes.LoadFail;

  constructor(public payload: string) {}
}

export class SaveScore implements Action {
  public readonly type = DealMetricsActionTypes.SaveScore;

  constructor(public payload: { dealId: string; score: string }) {}
}

export class SaveScoreSuccess implements Action {
  public readonly type = DealMetricsActionTypes.SaveScoreSuccess;
}

export class SaveScoreFail implements Action {
  public readonly type = DealMetricsActionTypes.SaveScoreFail;

  constructor(
    public payload: { dealId: string; score: string; error: string }
  ) {}
}

export class SaveRating implements Action {
  public readonly type = DealMetricsActionTypes.SaveRating;

  constructor(public payload: { dealId: string; rating: string }) {}
}

export class SaveRatingSuccess implements Action {
  public readonly type = DealMetricsActionTypes.SaveRatingSuccess;
}

export class SaveRatingFail implements Action {
  public readonly type = DealMetricsActionTypes.SaveRatingFail;

  constructor(
    public payload: { dealId: string; rating: string; error: string }
  ) {}
}

export class SaveOwnership implements Action {
  public readonly type = DealMetricsActionTypes.SaveOwnership;

  constructor(public payload: { dealId: string; ownership: boolean }) {}
}

export class SaveOwnershipSuccess implements Action {
  public readonly type = DealMetricsActionTypes.SaveOwnershipSuccess;
}

export class SaveOwnershipFail implements Action {
  public readonly type = DealMetricsActionTypes.SaveOwnershipFail;

  constructor(
    public payload: { dealId: string; ownership: boolean; error: string }
  ) {}
}

export class SaveStatus implements Action {
  public readonly type = DealMetricsActionTypes.SaveStatus;

  constructor(public payload: { dealId: string; status: string }) {}
}

export class SaveStatusSuccess implements Action {
  public readonly type = DealMetricsActionTypes.SaveStatusSuccess;
}

export class SaveStatusFail implements Action {
  public readonly type = DealMetricsActionTypes.SaveStatusFail;

  constructor(
    public payload: { dealId: string; status: string; error: string }
  ) {}
}
export type DealMetricsActionsUnion =
  | LoadDealMetrics
  | LoadDealMetricsSuccess
  | LoadDealMetricsFail
  | SaveScore
  | SaveScoreSuccess
  | SaveScoreFail
  | SaveRating
  | SaveRatingSuccess
  | SaveRatingFail
  | SaveOwnership
  | SaveOwnershipSuccess
  | SaveOwnershipFail
  | SaveStatus
  | SaveStatusSuccess
  | SaveStatusFail;
